import React, { memo } from 'react';
import { SmartDiaryEntry } from '../type';
import { SmartDiaryComment } from './SmartDiaryComment';

type SmartListItemActionProps = {
  smartEntry: SmartDiaryEntry;
};
export const SmartListItemAction: React.FC<SmartListItemActionProps> = memo(
  ({ smartEntry }: SmartListItemActionProps) => {
    return (
      <>
        <SmartDiaryComment smartEntry={smartEntry} />
      </>
    );
  }
);

SmartListItemAction.displayName = 'SmartListItemAction';
